
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    id: Number,
    subject: String,
    status: String,
    unreadCount: Number,
    clickHandler: Function,
    clickHandlerParameter: Object,
  },
})
export default class ThreeOptionsListGeneral extends Vue {}
